import { forwardRef, Ref } from 'react';
import classNames from 'classnames';
import { Fab, type KindKeys } from './styled';

interface IProps {
  kind?: KindKeys;
  active?: boolean;
  withMargin?: boolean;
  onClick?: () => void;
  icon?: JSX.Element;
  children?: any;
  style?: object;
  type?: 'submit' | 'reset' | 'button';
  disabled?: boolean;
  className?: any;
  classes?: {
    root?: string;
    label?: string;
    [key: string]: string | undefined;
  };
}

const ActionButton = forwardRef((props: IProps, ref: Ref<HTMLButtonElement>) => {
  const {
    kind = 'basic',
    active = false,
    withMargin = false,
    onClick = () => null,
    icon,
    children,
    classes = {},
    className,
    ...rest
  } = props;

  return (
    <Fab
      ref={ref}
      kind={kind}
      active={active}
      withMargin={withMargin}
      variant="extended"
      disableRipple
      size="small"
      onClick={onClick}
      className={classNames(className, classes.root)}
      {...rest}
    >
      {icon}
      {children}
    </Fab>
  );
});

export { ActionButton };
